import ForgotPassword2PageConfig from './auth/forgot-password-2/ForgotPassword2PageConfig';
import ForgotPasswordPageConfig from './auth/forgot-password/ForgotPasswordPageConfig';
import LockPageConfig from './auth/lock/LockPageConfig';
import Login2PageConfig from './auth/login-2/Login2PageConfig';
import LoginPageConfig from './auth/login/LoginPageConfig';
import MailConfirmPageConfig from './auth/mail-confirm/MailConfirmPageConfig';
import Register2PageConfig from './auth/register-2/Register2PageConfig';
import RegisterPageConfig from './auth/register/RegisterPageConfig';
import ResetPassword2PageConfig from './auth/reset-password-2/ResetPassword2PageConfig';
import ResetPasswordPageConfig from './auth/reset-password/ResetPasswordPageConfig';
import Error404PageConfig from './errors/404/Error404PageConfig';
import Error500PageConfig from './errors/500/Error500PageConfig';
import MaintenancePageConfig from './maintenance/MaintenancePageConfig';
import ProfilePageConfig from './profile/ProfilePageConfig';
import ClassicSearchPageConfig from './search/classic/ClassicSearchPageConfig';
import ModernSearchPageConfig from './search/modern/ModernSearchPageConfig';
import MemberConfig from './members/MemberConfig';
import AddMemberConfig from './members/add/AddMemberConfig';
import ProjectConfig from './projects/ProjectConfig';
import AddProjectConfig from './projects/add/AddProjectConfig';
import EditProjectConfig from './projects/edit/EditProjectConfig';
import MappingConfig from './mapping/MappingConfig';
import RecycleConfig from './recycle/RecycleConfig';
import InitializationConfig from './initialization/InitializationConfig';
import MultipleCompaniesConfig from './multipleCompanies/MultipleCompaniesConfig';
import CompanyDetailsConfig from './multipleCompanies/details/CompanyDetailsConfig';
import DeviceConfig from './devices/DeviceConfig';

import MapConfig from './dashboards/user/map/MapConfig';
import DashboardAdminConfig from './dashboards/admin/DashboardAdminConfig';
import DashboardUserProjectSelectedConfig from './dashboards/userWithProjectSelected/Config';




import SessionHistoryConfig from './sessionHistory/SessionHistoryConfig';
import CtmConfig from './ctm/CtmConfig';

const pagesConfigs = [
	LoginPageConfig,
	RegisterPageConfig,
	ResetPasswordPageConfig,
	ForgotPasswordPageConfig,
	MailConfirmPageConfig,
	LockPageConfig,
	Login2PageConfig,
	Register2PageConfig,
	ForgotPassword2PageConfig,
	ResetPassword2PageConfig,
	Error404PageConfig,
	Error500PageConfig,
	MaintenancePageConfig,
	ProfilePageConfig,
	ClassicSearchPageConfig,
	ModernSearchPageConfig,
	MemberConfig,
	ProjectConfig,
	MappingConfig,
	RecycleConfig,
	InitializationConfig,
	MultipleCompaniesConfig,
	CompanyDetailsConfig,
	DeviceConfig,
	AddProjectConfig,
	EditProjectConfig,
	MapConfig,
	DashboardAdminConfig,
	AddMemberConfig,
	DashboardUserProjectSelectedConfig,




	SessionHistoryConfig,
	CtmConfig,
];

export default pagesConfigs;
